import { Swiper, Navigation, Pagination, Thumbs } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Thumbs]);

export default () => {
    var swiper = new Swiper('.home__main-slider', {
        navigation: {
          nextEl: '.home-slide__next',
          prevEl: '.home-slide__prev',
        },
        pagination: {
            el: '.swiper-pagination'
        }
    });

    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.dicume-button__next',
            prevEl: '.dicume-button__prev',
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });

    var swiper = new Swiper('.aquavelas__slider', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.aquavelas-slide-next',
            prevEl: '.aquavelas-slide-prev',
        },
    });
};
